import { IConsultationRequestV2Schema } from '../../repositories/e2e-deal-entrypoints/entities/consultation_request/ConsultationRequestV2Schema';

export type TFormValues = Omit<IConsultationRequestV2Schema, 'origin'>;

export type TFormErrors = Partial<TFormValues> & { root?: string };

export type TFormSubmitStatus = { status?: TSubmitStatus; errors?: TFormErrors | null };

export enum TSubmitStatus {
  'Loading' = 'loading',
  'Error' = 'error',
  'Submit' = 'submit',
}
